import { getData } from 'helpers/dom'
import SwiperInstanceNative from 'customs/swiper-instance-native'
import SwiperInstanceComponent from 'customs/swiper-instance-component'
import './carousel-swiper.css'

class CarouselSwiper extends HTMLElement {
  constructor() {
    super()

    this.type = this.getAttribute('data-type') || null
    this.config = this.getAttribute('data-config') ? JSON.parse(getData('config', this)) : null
    this.options = this.getAttribute('data-options') ? JSON.parse(getData('options', this)) : null

    if (this.config && this.options) {
      this.options = {
        ...this.options
      }

      if (this.type === 'native') {
        this.instance = new SwiperInstanceNative(this, this.options, this.config, this.type)
      } else {
        this.instance = new SwiperInstanceComponent(this, this.options, this.config, this.type)
      }
    }
  }
}

if (!customElements.get('carousel-swiper')) {
  customElements.define('carousel-swiper', CarouselSwiper)
}
